import React from "react";
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const Barchart = (props) => {
  const labels = [];
  const dataset = [];
  const colors = ['#03A9F6', '#025F9E', '#59C98A',];
  for (let i = 0; i < props.PChart.length; i++) {
    labels.push(props.PChart[i]?.subjectName);
    dataset.push(props.PChart[i]?.grade || "L0")
  }
  console.log(labels,"test",dataset)
  
  const data = {
    labels: labels,
    datasets: [
      {
        data: dataset,
        // data: [...dataset].sort((a, b) => a.localeCompare(b)),
        backgroundColor: colors.slice(0, dataset.length),
        barThickness: 80,
      }
    ],
  };
  const options = {
    responsive: true,
    plugins: { legend: false, },
    scales: {
      x: { stacked: false, title: { display: true, text: 'Subjects' }, grid: { display: false, }, },
      y: {
        type: "category",
        reverse: true,
        // labels: ["G0", ...dataset?.map((g,index) => g.trim().length > 2 ? g.trim() + index : "G" + g.trim() + index)],
        labels: ["G0",...new Set([...dataset].sort((a, b) => a.localeCompare(b)))],
        title: { display: true, text: "Grades" },
        beginAtZero: true,
      }
    }
  };
  return (<Bar options={options} data={data} />)
};
export default Barchart;